import {MAIN_CONTENT_ID, PIED_DE_PAGE_ID} from "../shared-components/constants/accessibilityLinks"

export const ACCESSIBILITY_LINKS = [
    {label: "Aller au contenu principal", href: MAIN_CONTENT_ID},
    {label: "Aller au pied de page", href: PIED_DE_PAGE_ID},
]
